import type { ModalActionHandler } from './modalActionTypes';
import { unassignJob } from '../map/settlement';
import { getSettlement } from './settlementActionUtils';

export const fireFisherAction: ModalActionHandler = (state, modal) => {
    const settlement = getSettlement(state, modal);
    if (!settlement || settlement.jobs.fishers <= 0) return false;
    if (!unassignJob(settlement, 'fishers')) return false;
    settlement.production.fishing.progress.pop();
    return true;
};
